import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../Auth.css";

function Login() {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const mockLogin = async (email, password) => {
    await new Promise(resolve => setTimeout(resolve, 800));
    const mockUsers = [
      { email: "admin@gmail.com", password: "admin", role: "admin" },
    ];
    const user = mockUsers.find(u => u.email === email && u.password === password);
    if (user) {
      return {
        success: true,
        data: {
          token: "mock-token-" + Date.now(),
          user: { id: 1, email: user.email, role: user.role, name: "Admin User" }
        }
      };
    }
    return { success: false, error: "Invalid admin credentials" };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const result = await mockLogin(formData.email, formData.password);
      if (result.success) {
        localStorage.setItem("token", result.data.token);
        localStorage.setItem("user", JSON.stringify(result.data.user));
        navigate("/admin/dashboard");
      } else {
        setError(result.error);
      }
    } catch (err) {
      setError("An unexpected error occurred.");
    }
    setLoading(false);
  };

  return (
    <div className="auth-page">
      <div className="auth-wrapper">
        <div className="auth-visual" style={{background: '#1a4d31'}}>
          <h2>Admin Portal</h2>
          <p>Secure access for RepairMate administrators to manage orders, services, and customers.</p>
        </div>

        <div className="auth-content">
          <div className="auth-form-header">
            <h1 style={{color: '#1a4d31'}}>Admin Login</h1>
            <p>Access the management dashboard</p>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="auth-form-group">
              <label className="auth-label">Administrator Email</label>
              <div className="auth-input-wrapper">
                <i className="fas fa-user-shield"></i>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="admin@repairmate.com"
                  required
                  className="auth-input"
                />
              </div>
            </div>

            <div className="auth-form-group">
              <label className="auth-label">Password</label>
              <div className="auth-input-wrapper">
                <i className="fas fa-key"></i>
                <input
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="••••••••"
                  required
                  className="auth-input"
                />
              </div>
            </div>

            <button type="submit" disabled={loading} className="auth-submit-btn" style={{background: '#1a4d31'}}>
              {loading ? "Authenticating..." : "Login as Administrator"}
            </button>
            
            {error && <div style={{color: '#dc3545', marginTop: '15px', textAlign: 'center', fontSize: '0.9rem'}}>{error}</div>}
          </form>

          <div className="auth-footer">
            <Link to="/" className="auth-link">← Back to website</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;